import { Injectable } from '@angular/core';

@Injectable({ providedIn: 'root' })
export class TokenService {
  private readonly tokenName = 'Cnv';
  private readonly userToken = `token${this.tokenName}`;
  private readonly userTokenExpiration = `tokenExp${this.tokenName}`;
  private readonly userTokenPermission = `tokenPerm${this.tokenName}`;

  private readonly userTokenIncog = `tokenIncog${this.tokenName}`;
  private readonly userTokenExpirationIncog = `tokenExpIncog${this.tokenName}`;
  private readonly userTokenPermissionIncog = `tokenPermIncog${this.tokenName}`;
  private readonly userTokenRedirect = `tokenRedirect${this.tokenName}`;
  
  saveToken(accessToken: string): void {
    localStorage.setItem(this.userToken, accessToken);
  }

  saveTokenIncog(accessToken: string): void {
    localStorage.setItem(this.userTokenIncog, accessToken);
  }

  saveTokenExpiration(): void {
    const expiration = this.getJWTClaim('exp');
    const tokenIncog = this.getTokenIncog();
    if (expiration) localStorage.setItem(tokenIncog ? this.userTokenExpirationIncog : this.userTokenExpiration, expiration);
  }

  saveTokenPermission(): void {
    const permission = this.getJWTClaim('access_mode');
    const tokenIncog = this.getTokenIncog();
    if (permission) localStorage.setItem(tokenIncog ? this.userTokenPermissionIncog: this.userTokenPermission, permission);
  }

  saveTokenRedirect(): void {
    const redirect = this.getJWTClaim('redirect');
    if (redirect) localStorage.setItem(this.userTokenRedirect, redirect);
  }

  isReadOnly(): boolean{
    const tokenIncog = this.getTokenIncog();
    if (tokenIncog) {
        return true;
    }
    const permission = this.getJWTClaim('access_mode');
    if(permission){
      if(permission== 'readOnly') return true;
    }
    return false;
  }
  getToken(): string | null {
    return localStorage.getItem(this.userToken);
  }

  getTokenIncog(): string | null {
    return localStorage.getItem(this.userTokenIncog);
  }

  getRedirect(): string|null{
    return localStorage.getItem(this.userTokenRedirect);
  }

  getTokenExpiration(): string | null {
    const tokenIncog = this.getTokenIncog();
    if (tokenIncog) {
      return localStorage.getItem(this.userTokenExpirationIncog);
    } else {
      return localStorage.getItem(this.userTokenExpiration);
    }
  }

  getTokenPermission(): string | null {
    const tokenIncog = this.getTokenIncog();
    if (tokenIncog) {
      return localStorage.getItem(this.userTokenPermissionIncog);
    } else {
      return localStorage.getItem(this.userTokenPermission);
    }
  }


  isTokenExpired(): boolean {
    const tokenExpiration = this.getTokenExpiration();

    if (!tokenExpiration) return true;

    return +tokenExpiration * 1000 < Date.now();
  }

  removeTokenKeys(): void {
    const tokenIncog = this.getTokenIncog();
    if (!tokenIncog) {
      localStorage.removeItem(this.userToken);
      localStorage.removeItem(this.userTokenExpiration);
      localStorage.removeItem(this.userTokenPermission);
    } else {
      localStorage.removeItem(this.userTokenIncog);
      localStorage.removeItem(this.userTokenExpirationIncog);
      localStorage.removeItem(this.userTokenPermissionIncog);
      localStorage.removeItem(this.userTokenRedirect);
    }
  }


  getJWTClaim(claim: string): string {

    const tokenIncog = this.getTokenIncog();
    if (tokenIncog) {

      const dataToken = JSON.parse(atob(tokenIncog.split('.')[1]));
      return dataToken[claim];
    }
    const token = this.getToken();
    if (!token) return '';

    const dataToken = JSON.parse(atob(token.split('.')[1]));
    return dataToken[claim];
  }

  getActiveToken(): string | null {
    let token = this.getTokenIncog();
    if(!token){
      token = this.getToken();
    }
    return token ;
  }

  isLoginSharedWishList(): boolean{
    const shared = this.getJWTClaim('shared_wishlist')
     if(!shared){
      return false
     }
     return shared == ''? false : true;
    ;
  }

  isLoginJWT(): boolean{
    const shared = this.getJWTClaim('auth_provider')
     if(!shared){
      return false
     }
     return shared == ''? false : true;
    ;
  }

}
